import type { PushSubscriptionDto, UnsubscribeDto } from './dtos/models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PushService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  getVapidPublicKey = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, string>({
      method: 'GET',
      responseType: 'text',
      url: '/api/app/push/vapid-public-key',
    },
    { apiName: this.apiName,...config });
  

  subscribe = (input: PushSubscriptionDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/push/subscribe',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  unsubscribe = (input: UnsubscribeDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/push/unsubscribe',
      body: input,
    },
    { apiName: this.apiName,...config });
}